import React, {useState, useEffect} from "react";


export default function KursanmeldungDisplay() {
    return (
        <iframe src="https://www.tgbornheim.de/v3/app/?MOBILE=true#/kurse" width={1000} height={1000}/>
    )
}
